import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { SupplierDetails } from '@suppliers/models/supplier-details';
import * as supplierOtherCreditorsActions from '@feature/suppliers/actions/supplier-other-creditors.actions';
import * as supplierOtherCreditorSelectors from '@feature/suppliers/selectors/supplier-other-creditor.selectors';
import { SupplierOtherCreditorProfile } from '@admin/supplier-other-creditor/models/supplier-other-creditor-profile';


@Injectable({
    providedIn: 'root'
})
export class SupplierOtherCreditorService {

    constructor(
        private readonly store: Store<ApplicationState>,
    ) {
    }

    readonly supplierDetails: Observable<SupplierDetails>;

    load() {
        this.store.dispatch(supplierOtherCreditorsActions.load());
    }

    getSupplierOtherCreditorProfiles(): Observable<SupplierOtherCreditorProfile[]> {
        return this.store.select(supplierOtherCreditorSelectors.selectClientProfiles);
    }

    getLoading(): Observable<boolean> {
        return this.store.select(supplierOtherCreditorSelectors.selectLoading);
    }

}

